module.exports = {"API_URL":"https://m99r7332fd.execute-api.ap-southeast-1.amazonaws.com/prod-sg/v1/","SECRET_KEY":"secret"};